import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { FormModule } from '@woolworthsnz/form';
import { ProductModule } from '@woolworthsnz/product';
import { MODAL_ROUTES, ShopModule } from '@woolworthsnz/shop';
import { StoreLocatorLibModule } from '@woolworthsnz/store-locator';
import { StyleguideModule } from '@woolworthsnz/styleguide';
import {
	ChangePickupStoreModalComponent,
	ProductStockLevelIndicatorComponent,
	ProductStoreStockLevelModalComponent,
} from './components';
import { ProductDetailPage } from './pages/detail/detail.page';
import { ProductDetailsResolver } from './product-details.resolver';
import { EDRBoostsModule } from '@woolworthsnz/everyday-rewards';

const routes: Routes = [
	{
		path: 'productdetails',
		component: ProductDetailPage,
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
		resolve: {
			product: ProductDetailsResolver,
		},
		children: [
			{
				path: ':id',
				component: ProductDetailPage,
				resolve: {
					product: ProductDetailsResolver,
				},
				children: [
					{
						path: MODAL_ROUTES.PRODUCT_STORES_STOCK_LEVEL_MODAL_PATH,
						outlet: MODAL_ROUTES.PRODUCT_DETAILS_MODAL,
						loadComponent: () => import('./components').then((c) => c.ProductStoreStockLevelModalComponent),
					},
					{
						path: MODAL_ROUTES.CHANGE_STOREFRONT_PICKUP_STORE_PATH,
						outlet: MODAL_ROUTES.PRODUCT_DETAILS_MODAL,
						loadComponent: () => import('./components').then((c) => c.ChangePickupStoreModalComponent),
					},
				],
			},
			{
				path: MODAL_ROUTES.PRODUCT_STORES_STOCK_LEVEL_MODAL_PATH,
				outlet: MODAL_ROUTES.PRODUCT_DETAILS_MODAL,
				loadComponent: () => import('./components').then((c) => c.ProductStoreStockLevelModalComponent),
			},
			{
				path: MODAL_ROUTES.CHANGE_STOREFRONT_PICKUP_STORE_PATH,
				outlet: MODAL_ROUTES.PRODUCT_DETAILS_MODAL,
				loadComponent: () => import('./components').then((c) => c.ChangePickupStoreModalComponent),
			},
		],
		data: { gtmListName: 'ProductDetail' },
	},
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forChild(routes),
		ProductModule.forRoot(),
		StyleguideModule.forRoot(),
		OverlayModule,
		PortalModule,
		StoreLocatorLibModule,
		FormsModule,
		ReactiveFormsModule,
		FormModule,
		ShopModule,
		ChangePickupStoreModalComponent,
		ProductDetailPage,
		ProductStoreStockLevelModalComponent,
		ProductStockLevelIndicatorComponent,
		EDRBoostsModule,
	],
	providers: [ProductDetailsResolver],
})
export class ProductDetailModule {}
